// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__btp-Q","menuItem":"Menu_menuItem__i8-c3","menuActive":"Menu_menuActive__lMEtc","fontAwesomeIcon":"Menu_fontAwesomeIcon__IaDUg"};